import axios from "axios";
import Vue from "vue";
import Paginate from 'vuejs-paginate'
import SmoothScroll from "smooth-scroll";

export default class{
    
    constructor() {
        
        if(location.host == "localhost:3000" || location.host == "kawasakilife.willstyle.biz"){
            this.domain = "https://publish-p23257-e83870.adobeaemcloud.com"
             this.headers = {}
        }else{
            this.domain = "https://dp.tmn-agent.com"
             this.headers = {
                headers: {
                    "Access-Control-Allow-Origin": "*",
                },
            }
        }
        this.endpoint = this.domain + "/apps/tmnf/api/cf.json/common"
        this.categories = {
            "全般":"all",
            "火災":"fire", 
            "自動車":"car",
            "医療":"medical",
            "がん":"cancer",
            "傷害":"personal-accident",
            "個賠":"personal-liability",
            "所補":"income-compensation",
            "介護":"long-term-care",
            "海旅":"overseas-travel",
            "内旅":"domestic-travel",
            "サイクル":"bicycle",
            "ゴルファー":"golfer"
        }
        this.tags = {
            "全般":"all",
            "火災":"fire", 
            "自動車":"car",
            "医療":"medical",
            "がん":"cancer",
            "傷害":"personal-accident",
            "個賠":"personal-liability",
            "所補":"income-compensation",
            "介護":"long-term-care",
            "海旅":"overseas-travel",
            "内旅":"domestic-travel",
            "サイクル":"bicycle",
            "ゴルファー":"golfer",
            "入社":"new-employees",
            "車購入" :"car-parchase",
            "結婚" :"marriage",
            "子育て" :"parenting",
            "住宅購入" :"home-purchase",
            "親介護" :"parent-care",
            "退職" :"retirement",
            "共通" :"general",
            "趣味" :"hobbies",
            "全年齢" :"All-ages",
            "20代前半" :"ealry-20's",
            "20代後半" :"late-20's",
            "30代前半" :"ealry-30's",
            "30代後半" :"late-30's",
            "40代前半" :"ealry-40's",
            "40代後半" :"late-40's",
            "50代前半" :"ealry-50's",
            "50代後半" :"late-50's",
            "60代前半" :"ealry-60's",
            "60代後半" :"late-60's",
            "70代前半" :"ealry-70's",
            "70代後半" :"late-70's",
            "80代前半" :"ealry-80's",
            "80代後半" :"late-80's",
            "未検討" :"undecided",
            "検討初期" :"initial-consideration",
            "検討中期" :"mid-term-consideration",
            "検討後期" :"final-consideration",
        }
        
        this.limit = 10
        this.init()

        this.options = {
            ignore: '[data-scroll-ignore]',
            header: '[data-header]',
            speed: 400,
            offset: 20,
            speedAsDuration:true,
            easing: 'easeOutCubic',
            updateURL: false,
        };
        Vue.component('paginate', Paginate)
    }
    
    init(){

       
        const _self = this
        const columnEl = document.querySelector("#insuranse-columns")
        if(columnEl){
            this.columns = new Vue({
                el: '#insuranse-columns',
                data: {
                    domain : _self.domain,
                    endpoint: _self.endpoint,
                    columns : []
                },
                methods :{
                    sprit_tag (str){
                        return _self.sprit_tag(str)
                    },
                    get_date(date){
                        return _self.get_date(date)
                    },
                    get_tag_link(key){
                        if(_self.tags.hasOwnProperty(key)){
                            const stag = _self.tags[key]
                            return '/promotion-insurance/list/?stag=' + stag
                        }
                        return ""
                    }
                },
                mounted(){
                    const limit = columnEl.getAttribute("data-limit")
                    axios.get(this.endpoint + "?type=column&limit=" + limit,this.headers)
                    .then(res => {
                        this.columns = res.data.items
                        
                        this.$nextTick( () => {
                            _self.update()
                        },200)
        
                    })
                }
            })
        }

        const videoEl = document.querySelector("#insuranse-videos")
        if(videoEl){
            this.videos = new Vue({
                el: '#insuranse-videos',
                data: {
                    domain : _self.domain,
                    endpoint: _self.endpoint,
                    videos : []
                },
                methods :{
                    sprit_tag (str){
                        return _self.sprit_tag(str)
                    },
                    get_date(date){
                        return _self.get_date(date)
                    },
                    get_tag_link(key){
                        if(_self.tags.hasOwnProperty(key)){
                            const stag = _self.tags[key]
                            return '/promotion-insurance/list/?stag=' + stag
                        }
                        return ""
                    }
                },
                mounted(){
                    const limit = videoEl.getAttribute("data-limit")
                    axios.get(this.endpoint + "?type=video&limit=" + limit,this.headers)
                    .then(res => {
                        this.videos = res.data.items
                        this.$nextTick( () => {
                            _self.update()
                        },200)
                    })
                }
            })
        }

        
        const columnSingle = document.querySelector("#insuranse-single")
        if(columnSingle){
            this.single = new Vue({
                el: '#insuranse-single',
                data: {
                    domain : _self.domain,
                    endpoint: _self.endpoint,
                    column : {}
                },
                methods :{
                    sprit_tag (str){
                        return _self.sprit_tag(str)
                    },
                    get_date(date){
                        return _self.get_date(date)
                    },
                    replace_url(source){
                        // source
                        if(source){
                            return source.replaceAll('<img src="/','<img src="' + this.domain + '/')
                        }
                        return ""
                    },
                    get_tag_link(key){
                        if(_self.tags.hasOwnProperty(key)){
                            const stag = _self.tags[key]
                            return '/promotion-insurance/list/?stag=' + stag
                        }
                        return ""
                    }
                },
                mounted(){
                    const searchParams = new URLSearchParams(location.search)
                    axios.get(this.endpoint + "?type=column&type=video&name=" + searchParams.get("n"),this.headers)
                    .then(res => {
                        if(res.data.items.length > 0){
                            this.column = res.data.items[0]
                            let stag = ""
                            if(this.column.searchTag.length > 0){
                                if(_self.tags.hasOwnProperty(this.column.searchTag[0])){
                                    stag = _self.tags[this.column.searchTag[0]]
                                }
                            }
                            _self.relative_column(stag,this.column.name)
                            _self.bc(this.sprit_tag(this.column.title))
                            
                            this.$nextTick( () => {
                              _self.update()
                            },200)
                        }
        
                    })
                }
            })
        }


        const listsEl = document.querySelector("#insuranse-lists")
        const wrapper = document.querySelector("#insuranse-lists--wrapper")
        if(listsEl){
            this.columns = new Vue({
                el: '#insuranse-lists',
                data: {
                    domain : _self.domain,
                    endpoint: _self.endpoint,
                    columns : [],
                    pages: 0,
                    limit: _self.limit,
                    type : false
                },
                components: {
                    Paginate
                },
                methods :{
                    sprit_tag (str){
                        return _self.sprit_tag(str)
                    },
                    get_date(date){
                        return _self.get_date(date)
                    },
                    get_tag_link(key){
                        if(_self.tags.hasOwnProperty(key)){
                            const stag = _self.tags[key]
                            return '/promotion-insurance/list/?stag=' + stag
                        }
                        return ""
                    },
                    pagenate(pageNum){
                        this.fetch(pageNum)
                    },
                    fetch(pageNum){
                        const offset = ((pageNum - 1) * this.limit)
                        const searchParams = new URLSearchParams(location.search)
                        const params = searchParams.getAll("stag")
                        let stags = "&stag="
                        stags += params.join("&stag=").replace(/stag=$/,"")

                        let types = "type=column&type=video"

                        this.type = searchParams.get("type")
                        if(this.type){
                            types = "type=" + this.type
                            stags = ""
                        }

                        axios.get(this.endpoint + "?" + types + stags +"&limit=" + _self.limit + "&offset=" + offset,this.headers)
                        .then(res => {
                            this.columns = res.data.items
                            this.pages = Math.ceil(res.data.itemCnt / this.limit)
                           

                            this.$nextTick( () => {
                                _self.update()

                                const smoothScroll = new SmoothScroll();
                                smoothScroll.animateScroll( wrapper, {}, _self.options );
                            },200)
                        })
                    }
                },
                mounted(){

                    const keywords = document.querySelectorAll('[data-insurance-keyword] a')
                    if(keywords.length > 0){
                        keywords.forEach(k => {
                            if(k.href == location.href){
                                k.classList.add("-active")
                            }
                        });
                    }
                    this.fetch(1)
                }
            })
        }

    }

    update(){
        const sidebar = document.querySelector("#l-side")
        if(sidebar){
            if(window.Sidebar){
                setTimeout(() => {
                    window.Sidebar.updateSticky()
                }, 300);
            }
        }
    }
    sprit_tag (str){
        if(str)
        return str.replace(/<("[^"]*"|'[^']*'|[^'">])*>/g,'')
    }
    get_date(date){
        if(date == undefined){
            return ""
        }
        const month = ('00' + (date.month + 1) ).slice( -2 )
        const day = ('00' + (date.dayOfMonth) ).slice( -2 )
        return date.year + '/' + month + '/' + day
    }
    relative_column(stag,name){
        const _self = this
        const relationsEl = document.querySelector("#insuranse-relations")
        if(relationsEl){
            this.relations = new Vue({
                el: '#insuranse-relations',
                data: {
                    domain : _self.domain,
                    endpoint: _self.endpoint,
                    columns : []
                },
                methods :{
                    sprit_tag (str){
                        return _self.sprit_tag(str)
                    },
                    get_date(date){
                        return _self.get_date(date)
                    },
                    get_tag_link(key){
                        if(_self.tags.hasOwnProperty(key)){
                            const stag = _self.tags[key]
                            return '/promotion-insurance/list/?stag=' + stag
                        }
                        return ""
                    }
                },
                mounted(){
                    const limit = relationsEl.getAttribute("data-limit")
                    axios.get(this.endpoint + "?type=video&type=column&stag=" + stag + "&limit=" + limit,this.headers)
                    .then(res => {

                        this.columns = res.data.items.filter( c => c.name != name)
                    })
                }
            })
        }

    }
    bc(title){

        const breadcrumb = document.querySelector('#js-breadcrumb')
        if(breadcrumb){
            this.columns = new Vue({
                el: '#js-breadcrumb',
                data: {
                    title : title
                }
            })
        }
    }
}